import {Box, Skeleton} from '@mui/material';

import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import {departmentHealthActionCardBg} from '../../utils/DepartmentHealth/getDepartmentHealthActionItemStyles';

const cardSx = {
  border: '0.5px solid',
  borderColor: 'divider',
  borderRadius: '14px',
  px: 2.5,
  py: 2.25,
  mb: 2,
} as const;

export const DepartmentHealthRecommendedActionsSkeleton = () => {
  return (
    <EmpionPaper sx={cardSx}>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.5}}>
        <Skeleton variant='circular' width={15} height={15} />
        <Skeleton variant='text' width={140} height={18} />
        <Skeleton variant='text' width={180} height={16} sx={{marginLeft: 'auto'}} />
      </Box>
      {Array.from({length: 2}).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            gap: 1.5,
            px: 1.875,
            py: 1.625,
            borderRadius: '10px',
            border: '0.5px solid',
            borderColor: 'divider',
            bgcolor: departmentHealthActionCardBg,
            mb: index === 0 ? 1 : 0,
          }}
        >
          <Skeleton variant='rounded' width={32} height={32} sx={{borderRadius: '8px', flexShrink: 0}} />
          <Box sx={{flex: 1}}>
            <Skeleton variant='text' width={140} height={14} sx={{mb: 0.5}} />
            <Skeleton variant='text' width='95%' height={16} />
            <Skeleton variant='text' width='85%' height={14} />
          </Box>
          <Skeleton variant='rounded' width={44} height={20} sx={{borderRadius: '5px', flexShrink: 0}} />
        </Box>
      ))}
    </EmpionPaper>
  );
};
